<!-- default UI -->
<template>
    <div class="resume-default--container" :class="_platform">
        <!-- <ExperienceSelect v-show="true" /> -->
        <img class="resume-banner" :src="_srcBanner" alt="" />
        <div class="resume-wrap_form">
            <resume-form ref="resumeForm" @on-success="handlerSuccess" />
        </div>
        <div class="resume-btn_post" @click="handlerResume">{{ _btnText }}</div>
    </div>
</template>
<script>
/* eslint-disable camelcase */
import ResumeForm from '../components/form';
import track from '../utils/track';
import trackNew from '../utils/trackNew';

export default {
    components: { ResumeForm },
    data() {
        return {};
    },
    computed: {
        _btnText() {
            // eslint-disable-next-line no-nested-ternary
            return this.$root.state === 'edit' ? '修改并保存' : (this.$root.infoId ? '创建并投递' : '保存');
        },
        isEdit() {
            return this.$root.state === 'edit';
        },
        _srcBanner() {
            const config = {
                ganji: {
                    edit: '//wos2.58cdn.com.cn/iJkFeDcBiJiJ/rocket/gyR8pZUKg.jpg',
                    create: '//wos2.58cdn.com.cn/iJkFeDcBiJiJ/rocket/ECSQ89UPG.jpg'
                },
                default: {
                    edit: '//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/tli26j86.png',
                    create: '//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/ghhfkua8.png'
                }
            };
            return config[this._platform || 'default'][this.isEdit ? 'edit' : 'create'];
        },
        _platform() {
            return window.urlParams?.platform;
        }
    },
    methods: {
        handlerResume() {
            this.$refs.resumeForm.validateAndResume();
            /**
             * 投递上报
             */
            track({
                d: {
                    page_type: 1001,
                    element_id: 81
                }
            });
            // eslint-disable-next-line no-nested-ternary
            const element_id = this.$root.state === 'edit' ? 15 : (this.$root.infoId ? 11 : 15);
            trackNew({
                action: 1003,
                element_id: element_id,
                module_id: 'other',
                element_param: {type: 'save'}
            }, this.$root.$data.trackLog);
        },
        // 创建成功
        handlerSuccess() {
            this.$toasted.show('创建成功');
        }
    }
};
</script>
